module.exports = __webpack_public_path__ + "img/discount-img.e32a3b54.svg";